module.exports = {
  options: {
    routerIgnore: [], // List of parameters to ignore in the router (will not be added to the URL)
  },
};
